import router from '@/router'
import { allowOnlyWithCompletedJourney } from '@/router/routerGuards'
import { AppSidebar, AppHeader } from '@/components'
import FooterOutgoingLinks from '@/components/FooterOutgoingLinks.vue'

export const routes = [
  {
    path: '/data-room/:step?',
    name: 'data-room',
    components: {
      default: () => import('./dataRoom.vue'),
      sidebar: AppSidebar,
      header: AppHeader,
      footer: FooterOutgoingLinks
    },
    meta: {
      sitemap: {
        title: 'Documents',
        description: 'Manage financial documents',
        pathParams: [
          {
            name: 'step',
            description:
              'Optional category to filter the documents by. One of: bankStatements, filedAccounts, managementAccounts, outstandingDebt, cashflowForecast, agedDebtors, agedCreditors, proofOfId, pitchDeck, other. Omit it to show all documents.'
          }
        ]
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    beforeEnter: allowOnlyWithCompletedJourney()
  }
]

export default () => {
  routes.forEach(route => router.addRoute(route))
}
